export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;

export const getDeferredInstallPrompt = (): BeforeInstallPromptEvent | null =>
  deferredInstallPrompt;

export const clearDeferredInstallPrompt = (): void => {
  deferredInstallPrompt = null;
};

export const captureBeforeInstallPrompt = (): (() => void) => {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const onBeforeInstallPrompt = (event: Event) => {
    event.preventDefault();
    deferredInstallPrompt = event as BeforeInstallPromptEvent;
  };

  window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);

  return () => {
    window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
  };
};

export const promptNativeInstall = async (): Promise<
  "accepted" | "dismissed" | "unavailable"
> => {
  const deferred = deferredInstallPrompt;
  if (!deferred) {
    return "unavailable";
  }

  try {
    await deferred.prompt();
    const choice = await deferred.userChoice;
    clearDeferredInstallPrompt();
    return choice.outcome;
  } catch (error) {
    console.error("Native A2HS install prompt failed:", error);
    clearDeferredInstallPrompt();
    return "unavailable";
  }
};
